import {Page} from "../../design";
import React, {useEffect} from "react";
import {Col} from "react-awesome-styled-grid";
type Props = {
  isOpen: boolean,
  children: Node
}

const Modal = (props:Props) => {
    return (
      props.isOpen && <Page
        id="modal"
        style={{
          position: 'fixed',
          left: 0,
          top: 0,
          backdropFilter: 'blur(2px)',
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflowY: "auto",
          overflowX: "hidden",
          width:'100%',
          height: '100%',
          zIndex: 1024,
          transition: 'opacity .15s linear'
        }}
      >
        <Col className="my-2" xs={3} sm={4} md={4} lg={5} xl={4} >
          { props.children}
        </Col>
      </Page>
    );
};

export default Modal;
